// Module
var code = "<p>The torus's radius is linked to the bounding box of the sphere and the box.</p> <p> <label>Box Center</label> <input type=\"range\" min=\"0\" max=\"10\" step=\"0.01\" value=\"3\" oninput=\"box.p.center.x.set(event.target.value)\"> </p>";
// Exports
export default code;